import {Component, Input, OnInit} from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";

import {getSiteStatusStyle} from "app/lib/lib";
import {SiteInfoService} from "./site_info.service";

interface SiteInfoConfig {
	dashboardUrl: string;
}

@Component({
	selector: 'site_info',
	template: `
		<div>
			<gotosupport
				[@stateAnimation]="myStatusExp"
				[queryParams]="{value: siteUrl, typeFilter: 'site'}"
			>
				<i
					[style.color]="color"
					class="fa fa-info-circle"
					aria-hidden="true"
				></i>
			</gotosupport>
			&nbsp;
			<a
				target="_blank"
				rel="noreferrer"
				[href]="'http://' + siteUrl"
			>
				{{ siteUrl }}
			</a>
			&nbsp;
			<a
				*ngIf="siteInfoConfig.dashboardUrl"
				class=" ul-status ul-dashboard"
				[href]="siteInfoConfig.dashboardUrl"
				target="_blank"
			>
				<i class="fa fa-tachometer-alt" aria-hidden="true"></i>
			</a>
		</div>
	`,
	animations: [
		trigger('stateAnimation', [
			transition('* => incomplete', [
				style({ opacity: 1 }),
				animate('500ms ease-in', style({ opacity: 0 })),
				animate('500ms ease-in', style({ opacity: 1 })),
				animate('500ms ease-in', style({ opacity: 0 })),
				animate('500ms ease-in', style({ opacity: 1 })),
				animate('500ms ease-in', style({ opacity: 0 })),
				animate('500ms ease-in', style({ opacity: 1 })),
				animate('500ms ease-in', style({ opacity: 0 })),
				animate('500ms ease-in', style({ opacity: 1 })),
				animate('500ms ease-in', style({ opacity: 0 })),
				animate('500ms ease-in', style({ opacity: 1 })),
				animate('500ms ease-in', style({ opacity: 0 })),
				animate('500ms ease-in', style({ opacity: 1 })),
			]),
			transition('incomplete => complete', [
				style({ opacity: 1 }),
			]),
		]),
	]
})
export class SiteInfoComponent implements OnInit {
	@Input('siteUrl') siteUrl: string;
	@Input('config') siteInfoConfig: SiteInfoConfig;
	
	color: string = 'black';
	getSiteStatusStyle = getSiteStatusStyle;
	
	myStatusExp: string = 'init';
	
	constructor(public service: SiteInfoService) {
		this.myStatusExp = 'init';
		
		this.siteInfoConfig = { ...this.siteInfoConfig, dashboardUrl: '', };
	}
	
	async ngOnInit() {
		if ( ! this.siteUrl) {
			return ;
		}
		
		this.myStatusExp = 'incomplete';
		
		const siteData = await this.service.get(this.siteUrl).toPromise();
		if (siteData) {
			this.color = this.getSiteStatusStyle(siteData);
		}
		
		this.myStatusExp = 'complete';
	}
}
